/* global __webpack_public_path__ */

if (window.rccFrontend && window.rccFrontend.assetBaseUrl) {
  __webpack_public_path__ = window.rccFrontend.assetBaseUrl;
}
